<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">Current credits: {{ getPaymentValue('trainerCredits') }}</h3>
    </v-card-title>

    <v-card-title primary-title>
      <h3 class="headline mb-0">Payments</h3>
    </v-card-title>

    <v-card-text v-if="showError">
      <v-alert v-model="showError" type="error" icon="warning" dismissible>{{ errorMessage }}</v-alert>
    </v-card-text>

    <v-card-text v-if="showInfo">
      <v-alert v-model="showInfo" type="info" icon="info" dismissible>{{ infoMessage }}</v-alert>
    </v-card-text>

    <v-card-text>
      <v-card v-for="(payment, index) in archive" :key="`fruit-${index}`" class="innerCard" :class="getPaymentArchiveValue(index, 'confirmed') ? 'confirmed' : 'notConfirmed'">
        <v-card-text class="">
          <v-layout row align-start justify-space-between>
            <v-flex shrink>{{ getPaymentArchiveValue(index, 'date') }}</v-flex>
            <v-flex shrink><span class="color-gray">Credits:</span>&nbsp;<span class="color-primary font-weight-bold">{{ getPaymentArchiveValue(index, 'usersNumber') }}</span></v-flex>
            <v-flex shrink class="color-primary font-weight-bold">{{ getPaymentArchiveValue(index, 'currency') }} {{ getPaymentArchiveValue(index, 'amount') }}</v-flex>
          </v-layout>
          <!-- <p>Order {{ getPaymentArchiveValue(index, 'confirmed') ? '' : 'not' }} confirmed</p> -->
          <!-- <p>Date: {{ getPaymentArchiveValue(index, 'date') }}</p> -->
          <!-- <p>Credits: {{ getPaymentArchiveValue(index, 'usersNumber') }}</p> -->
          <!-- <p>Total: {{ getPaymentArchiveValue(index, 'currency') }} {{ getPaymentArchiveValue(index, 'amount') }}</p> -->
          <!-- <li>clientSecret: {{ getPaymentArchiveValue(index, 'clientSecret') }}</li> -->
        </v-card-text>
<!--
        <v-container
        fill-height
        fluid
        pa-2
        >
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline white--text" v-text="card.title"></span>
            </v-flex>
          </v-layout>
        </v-container>
-->
      </v-card>
    </v-card-text>
<!--
    <v-dialog
    v-model="dialogRemove"
    width="500">
      <v-card>
        <v-card-title
        class="headline grey lighten-2"
        primary-title
        >Remove Credit Card?</v-card-title>
        <v-card-text v-if="selectedCreditCard">
          Are you sure you want to remove the credit card "{{ selectedCreditCard.card }}" permanently?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          color="primary"
          flat
          @click="dialogRemove = false"
          >Cancel</v-btn>
          <v-btn
          color="primary"
          flat
          @click="removeCreditCard"
          >Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
-->
  </v-card>
</template>

<script>
// import { auth } from '@/firebase.js';
// import { stripe } from '@/firebase.js'
import { createNamespacedHelpers } from "vuex";
// const namespacedHelperUsersAuth = createNamespacedHelpers("auth");
// const mapStateAuth = namespacedHelperUsersAuth.mapState;
const { mapState, mapActions } = createNamespacedHelpers("pay");

export default {
  name: "Payments",

  mixins: [],

  // mounted: function () {
  //   this.stripeElements = stripe.elements();
  //   const style = {
  //     base: {
  //       color: '#000'
  //     },
  //     invalid: {
  //     }
  //   }
  //   this.stripeCard = this.stripeElements.create('card', {style});
  //   this.stripeCard.mount(this.$refs.stripeCard);
  // },

  data() {
    return {
      debug: false,

      // stripeElements: null,
      // stripeCard: null,

      // dialogRemove: false,
      // selectedCreditCard: null,
      // selectedCreditCardIndex: null,

      showError: false,
      errorMessage: "",

      showInfo: false,
      infoMessage: ""
    };
  },

  props: {},

  watch: {},

  computed: {
    // user() {
    //   return this.$store.state.auth.user;
    // },

    ...mapState({
      // isUpdatingPayment: state => state.isUpdatingPayment, // map `this.isUpdatingPayment` to `this.$store.state.pay.isUpdatingPayment`
      payments: state => state.payments, // map `this.payments` to `this.$store.state.pay.payments`
      archive: state => state.archive, // map `this.archive` to `this.$store.state.pay.archive`
    }),

  },

  methods: {
    ...mapActions([
      // 'addStripeCreditCard', // map `this.addStripeCreditCard(card)` to `this.$store.dispatch('pay/addStripeCreditCard', card)`
      // 'removeStripeCreditCard' // map `this.removeStripeCreditCard(paymentMethodId)` to `this.$store.dispatch('pay/removeStripeCreditCard', paymentMethodId)`
    ]),

    getPaymentValue (property) {
      if (this.debug) console.log(this.$options.name+'.getPaymentValue() property:', property, 'payments:', this.payments);
      if (this.payments) {
        if (this.debug) console.log(this.$options.name+'.getPaymentValue() return...:', this.payments[property]);
        if (property === 'trainerCredits' && !this.payments[property]) {
          return 0;
        }
        return this.payments[property];
      }
      return null;
    },
    getPaymentArchiveValue (paymentId, property) {
      if (this.debug) console.log(this.$options.name+'.getPaymentArchiveValue() paymentId: ', paymentId, 'property:', property);
      if (this.archive && this.archive[paymentId] && this.archive[paymentId][property]) {
        const paymentDetail = this.archive[paymentId][property];
        if (this.debug) console.log(this.$options.name+'.getPaymentArchiveValue() paymentDetail:', paymentDetail);
        switch (property) {
        case 'date': {
          if (this.debug) console.log(this.$options.name+'.getPaymentArchiveValue() paymentDetail.seconds:', paymentDetail.seconds);
          const momentDate = this.$moment.unix(paymentDetail.seconds);
          if (this.debug) console.log(this.$options.name+'.getPaymentArchiveValue() momentDate:', momentDate);
          return momentDate.format('YYYY-MM-DD, HH:mm');
        }
        case 'currency': {
          if (paymentDetail === 'eur') {
            return '€';
          }
          break;
        }
        case 'amount': {
          const total = (paymentDetail / 100).toFixed(2);
          if (this.debug) console.log(this.$options.name+'.getPaymentArchiveValue() total:', total);
          return total;
        }
        case 'usersNumber':
          if (!paymentDetail) return 0;
          break;
        // case 'confirmed': break;
        }
        if (this.debug) console.log(this.$options.name+'.getPaymentArchiveValue() return...:', paymentDetail);
        return paymentDetail;
      }
      return null;
    },

    // addCreditCard () {
    //   if (this.debug) console.log(this.$options.name + ".addCreditCard()");
    //   this.addStripeCreditCard(this.stripeCard)
    //   .then(() => {
    //     if (this.debug) console.log(this.$options.name+'.addCreditCard() credid card added')
    //     this.showError = false
    //     this.stripeCard.clear();
    //   })
    //   .catch((error) => {
    //     if (this.debug) console.log(this.$options.name+'.addCreditCard() error['+(typeof error)+']:',error)
    //     this.errorMessage = error
    //     this.showError = true
    //   })
    // },

    // removeCreditCard (paymentMethodId) {
    // removeCreditCard () {
    //   this.dialogRemove = false;
    //   // if (this.debug) console.log(this.$options.name + ".removeCreditCard() paymentMethodId:", paymentMethodId);
    //   if (this.debug) console.log(this.$options.name + '.removeCreditCard() selectedCreditCard:', this.selectedCreditCard);
    //   if (this.selectedCreditCard) {
    //     if (this.debug) console.log(this.$options.name + '.removeCreditCard() selectedCreditCard.id:', this.selectedCreditCard.id);
    //     // this.removeStripeCreditCard(paymentMethodId)
    //     this.removeStripeCreditCard(this.selectedCreditCard.id)
    //     .then(() => {
    //       if (this.debug) console.log(this.$options.name+'.removeCreditCard() credid card removed')
    //       this.showError = false;
    //       this.selectedCreditCard = null;
    //     })
    //     .catch((error) => {
    //       if (this.debug) console.log(this.$options.name+'.removeCreditCard() error['+(typeof error)+']:',error)
    //       this.errorMessage = error;
    //       this.showError = true;
    //       this.selectedCreditCard = null;
    //     })
    //   }
    // }

  }
};
</script>

<style scoped> /* "scoped" attribute limit the CSS to this component only */
.innerCard {
  margin-top: 10px;
}
/* .innerCard.confirmed {
  background-color: #e8f5e9;
} */
.innerCard.notConfirmed {
  background-color: #ffcdd2;
}
</style>